import React, { useState } from 'react';
import FAQ from './FAQ';
import HomepageVisualCards from './HomepageVisualCards';

function Index() {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (newsletterEmail.trim()) {
      setSubscribed(true);
      setTimeout(() => {
        setNewsletterEmail('');
        setSubscribed(false);
      }, 3000);
    }
  };

  const homepageFaqs = [
    {
      question: "What is Mokshiq Fintech Platform?",
      answer: "Mokshiq (powered by Rakle Service Private Limited) is a B2B and B2C financial services ecosystem offering AEPS, Domestic Money Transfer (DMT), Micro-ATM, Utility Bill Payments (BBPS), Mobile/DTH Recharges, Verify APIs, and E-Commerce software."
    },
    {
      question: "How fast are AEPS and Money Transfer settlements?",
      answer: "All AEPS cash withdrawals and DMT transaction payouts process instantly with direct IMPS/NEFT routing, guaranteed 99.9% uptime, and zero hidden charges."
    },
    {
      question: "Which APIs are available for developer integration?",
      answer: "We provide developer-friendly REST APIs for Recharge, Fastag, Bill Payments, Bank Account Penny Drop, PAN/Aadhaar Verification, GSTIN Lookup, and Courier Booking."
    },
    {
      question: "Is customer support available 24x7?",
      answer: "Yes! Our dedicated support team is available round-the-clock via Phone (+91 7311104571 / +91 6394856756), WhatsApp, and email at sales@mokshiq.in."
    }
  ];

  return (
    <main className="page_content bg-dark-emerald text-white">

      {/* Hero Section */}
      <section className="hero_section hero_investment_solution section_decoration overflow-hidden py-5 position-relative" style={{ backgroundColor: '#012b2a' }}>
        <div className="container py-lg-4">
          <div className="row align-items-center justify-content-lg-between g-4">
            
            <div className="col-lg-6">
              <div className="pe-lg-3">
                <span className="badge-lime mb-3 text-uppercase font-weight-bold shadow-sm" style={{ letterSpacing: '1px' }}>
                  Mokshiq
                </span>
                
                <h1 className="hero_title text-white fw-bold display-4 mb-3" style={{ lineHeight: '1.2' }}>
                  Financial Solutions for the Future
                </h1>
                
                <p className="text-white-50 fs-5 mb-4" style={{ lineHeight: '1.7', maxWidth: '580px' }}>
                  We bring together AEPS, Domestic Money Transfer, mATM, Utility Bill Payments, Recharges, and more on a single secure platform — making financial and digital services seamless, reliable, and accessible for everyone.
                </p>
                
                <div className="d-flex flex-wrap align-items-center gap-4 mb-3">
                  <a className="btn-lime shadow-lg" href="/contact_us">
                    <span className="fw-bold">Join Today</span>
                    <i className="fa-solid fa-arrow-right ms-2"></i>
                  </a>

                  <div className="rating_block d-flex align-items-center bg-emerald-card p-2 px-3 rounded-4 border">
                    <div className="rating_admin me-2">
                      <img src="assets/images/clients/client_logo_1.webp" alt="Client Logo" className="rounded-circle" width="36" height="36" />
                    </div>
                    <div className="rating_content">
                      <div className="rating_icons text-warning" style={{ fontSize: '12px' }}>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star-half-stroke"></i>
                        <strong className="text-white ps-2 font-weight-bold">4.8</strong>
                      </div>
                      <div className="rating_counter text-white-50 small" style={{ fontSize: '11px' }}>260+ Reviews</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Hero Image Unit with Generated High-Res Woman & Neon App Card */}
            <div className="col-lg-6">
              <div className="position-relative p-2 text-center">
                <img 
                  src="/assets/images/hero/homepage_hero_fintech_woman.png" 
                  alt="Mokshiq Financial Solutions for the Future" 
                  className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover border border-emerald"
                  style={{ maxHeight: '460px', borderColor: 'rgba(204, 255, 0, 0.2)' }}
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about_section section_decoration overflow-hidden py-5" style={{ backgroundColor: '#00241b' }}>
        <div className="container py-3">
          <div className="row align-items-center justify-content-lg-between g-4">
            
            <div className="col-lg-6">
              <div className="heading_block">
                <h2 className="heading_text text-white display-6 font-weight-bold mb-3">Smart Financial Solutions for Everyone</h2>
                <p className="heading_description text-white-50 mb-4" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
                  At Mokshiq, we bring together AEPS, DMT, mATM, Utility Bill Payments, Recharges, and more into one seamless platform. Our focus is on secure, fast, and user-friendly services.
                </p>
              </div>

              <div className="row my-4 g-3">
                <div className="col-6">
                  <div className="funfact_block p-3 rounded-4 bg-emerald-card text-center border">
                    <div className="funfact_value display-5 font-weight-bold text-lime">
                      <span>50+</span>
                    </div>
                    <h4 className="funfact_title mb-0 text-white small font-weight-bold">Services</h4>
                  </div>
                </div>
                <div className="col-6">
                  <div className="funfact_block p-3 rounded-4 bg-emerald-card text-center border">
                    <div className="funfact_value display-5 font-weight-bold text-lime">
                      <span>7+</span>
                    </div>
                    <h4 className="funfact_title mb-0 text-white small font-weight-bold">Years Experience</h4>
                  </div>
                </div>
              </div>

              <div className="btns_group pb-0 justify-content-start">
                <a className="btn-lime shadow" href="/about_us">
                  <span className="fw-bold">About Us</span>
                  <i className="fa-solid fa-arrow-right ms-2"></i>
                </a>
              </div>
            </div>

            {/* Laptop Macbook Pro Display Image */}
            <div className="col-lg-6">
              <div className="about_image text-center p-2">
                <img 
                  src="/assets/images/about/homepage_macbook_fintech.png" 
                  alt="Mokshiq Smart Financial Solutions Laptop" 
                  className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover border"
                  style={{ maxHeight: '420px', borderColor: 'rgba(204, 255, 0, 0.2)' }}
                />
              </div>
            </div>

          </div>

          {/* 3 Clean Dark Emerald Feature Cards with 3D Generated Icons & Interactive Hover */}
          <div className="mt-5 pt-3">
            <div className="row g-4">
              
              {/* Card 1: Our Mission */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/mission_3d_target.png" alt="Our Mission 3D" width="42" height="42" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Our Mission</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Making financial and digital services accessible to everyone with secure, reliable, and fast solutions.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2: What We Offer */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/offer_3d_services.png" alt="What We Offer 3D" width="42" height="42" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">What We Offer</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      AEPS, DMT, mATM, Utility Bill Payments, and Recharges in one place for hassle-free operations.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3: Why Choose Us */}
              <div className="col-lg-4">
                <div className="about_feature_card_hover p-4 h-100 d-flex flex-column justify-content-between shadow-sm">
                  <div>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="feature_img_box flex-shrink-0">
                        <img src="/assets/images/about/choose_3d_growth.png" alt="Why Choose Us 3D" width="42" height="42" className="object-fit-contain" />
                      </div>
                      <h3 className="card_title_text h4 font-weight-bold mb-0">Why Choose Us</h3>
                    </div>
                    <p className="text-white-50 small mb-0" style={{ lineHeight: '1.7', fontSize: '0.94rem' }}>
                      Data-driven approach, 99.9% uptime SLA, transparent margins, and dedicated 24x7 customer support.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* SECURITY & RISK CARDS SECTION (RECREATED FROM REFERENCE IMAGE) */}
      <section className="visual_cards_section py-5" style={{ backgroundColor: '#012b2a', borderTop: '1px solid rgba(204, 255, 0, 0.1)', borderBottom: '1px solid rgba(204, 255, 0, 0.1)' }}>
        <div className="container">
          <HomepageVisualCards />
        </div>
      </section>

      {/* Services Section with Interactive Hover Effects & High-Contrast Readability */}
      <section className="service_section section_decoration overflow-hidden py-5" style={{ backgroundColor: '#001f18' }}>
        <div className="container py-3">
          
          {/* High Contrast Header */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-7 text-center">
              <span className="badge-lime mb-3 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
                OUR MULTIPLE SERVICES
              </span>
              <h2 className="heading_text text-white display-5 font-weight-bold mb-3">
                Our App Multiple Services
              </h2>
              <p className="heading_description mb-0 font-weight-medium fs-5" style={{ color: '#e2e8f0', lineHeight: '1.6' }}>
                Fast, secure &amp; reliable financial and digital services in one portal.
              </p>
            </div>
          </div>

          <div className="row g-4">
            
            {/* Card 1: Banking Services */}
            <div className="col-lg-4">
              <div className="service_card_hover p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="service_icon_box flex-shrink-0">
                      <img src="/assets/images/services/service_3d_banking.png" alt="Banking Services 3D" width="38" height="38" className="object-fit-contain" />
                    </div>
                    <h3 className="service_title text-white h4 font-weight-bold mb-0">
                      <a href="/aeps_dmt_services" className="text-white text-decoration-none">Banking Services</a>
                    </h3>
                  </div>
                  <p className="text-white-50 small mb-4" style={{ fontSize: '0.94rem', lineHeight: '1.7' }}>
                    Simplifying banking with AEPS, money transfer, bill payments &amp; mATM.
                  </p>
                </div>
                <div>
                  <a className="read_more_btn" href="/aeps_dmt_services">
                    <span>Read More</span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Card 2: Utility Bill Solutions */}
            <div className="col-lg-4">
              <div className="service_card_hover p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="service_icon_box flex-shrink-0">
                      <img src="/assets/images/services/service_3d_utility.png" alt="Utility Bill Solutions 3D" width="38" height="38" className="object-fit-contain" />
                    </div>
                    <h3 className="service_title text-white h4 font-weight-bold mb-0">
                      <a href="/utility_bill_payment" className="text-white text-decoration-none">Utility Bill Solutions</a>
                    </h3>
                  </div>
                  <p className="text-white-50 small mb-4" style={{ fontSize: '0.94rem', lineHeight: '1.7' }}>
                    Pay electricity, gas, water, and EMI bills anytime — quick and hassle-free.
                  </p>
                </div>
                <div>
                  <a className="read_more_btn" href="/utility_bill_payment">
                    <span>Read More</span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Card 3: Digital Recharge Suite */}
            <div className="col-lg-4">
              <div className="service_card_hover p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex align-items-center gap-3 mb-3">
                    <div className="service_icon_box flex-shrink-0">
                      <img src="/assets/images/services/service_3d_recharge.png" alt="Digital Recharge Suite 3D" width="38" height="38" className="object-fit-contain" />
                    </div>
                    <h3 className="service_title text-white h4 font-weight-bold mb-0">
                      <a href="/recharge_api" className="text-white text-decoration-none">Digital Recharge Suite</a>
                    </h3>
                  </div>
                  <p className="text-white-50 small mb-4" style={{ fontSize: '0.94rem', lineHeight: '1.7' }}>
                    Prepaid Mobile &amp; DTH recharge APIs with instant automatic LAPU switcher.
                  </p>
                </div>
                <div>
                  <a className="read_more_btn" href="/recharge_api">
                    <span>Read More</span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Leadership Team Section */}
      <section className="team_section py-5" style={{ backgroundColor: '#012b2a' }}>
        <div className="container py-3">
          <div className="row justify-content-center mb-5">
            <div className="col-lg-7 text-center">
              <span className="badge-lime mb-2 text-uppercase font-weight-bold" style={{ letterSpacing: '1px' }}>
                EXECUTIVE LEADERSHIP
              </span>
              <h2 className="heading_text text-white display-6 font-weight-bold">Meet Our Leadership Team</h2>
              <p className="heading_description mb-0 text-white-50">
                Meet our founders at Mokshiq. With expertise in finance, technology, and strategy, they drive our success forward.
              </p>
            </div>
          </div>

          <div className="row justify-content-center g-4">
            
            {/* Rohit Kushwaha */}
            <div className="col-lg-4 col-md-6">
              <div className="executive_team_card text-center h-100 shadow">
                <div className="member_photo_frame">
                  <img src="assets/images/avatar/rohit_kushwaha.jpeg" alt="Rohit Kushwaha" />
                </div>
                <div>
                  <h3 className="member_name">Rohit Kushwaha</h3>
                  <span className="member_role">Co-Founder</span>
                  <div className="d-flex justify-content-center gap-3 mt-2">
                    <a aria-label="Calling" href="tel:+916394856756" className="social_btn" title="Call Rohit">
                      <i className="fa-solid fa-phone"></i>
                    </a>
                    <a aria-label="Linkedin" href="https://www.linkedin.com/in/rohitkushwaha-rs/" target="_blank" rel="noreferrer" className="social_btn" title="LinkedIn Profile">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                    <a aria-label="Instagram" href="https://www.instagram.com/yes_rohit/" target="_blank" rel="noreferrer" className="social_btn" title="Instagram Profile">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Sitaram Gauda */}
            <div className="col-lg-4 col-md-6">
              <div className="executive_team_card text-center h-100 shadow">
                <div className="member_photo_frame">
                  <img src="assets/images/team/team_member_image_2.webp" alt="Sitaram Gauda" />
                </div>
                <div>
                  <h3 className="member_name">Sitaram Gauda</h3>
                  <span className="member_role">Co-Founder</span>
                  <div className="d-flex justify-content-center gap-3 mt-2">
                    <a aria-label="Calling" href="tel:+917311104571" className="social_btn" title="Call Sitaram">
                      <i className="fa-solid fa-phone"></i>
                    </a>
                    <a aria-label="Linkedin" href="#!" className="social_btn" title="LinkedIn Profile">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                    <a aria-label="Instagram" href="#!" className="social_btn" title="Instagram Profile">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <div className="bg-dark-emerald py-4">
        <FAQ 
          faqList={homepageFaqs}
          title="Everything You Need to Know About Mokshiq" 
          subtitle="Find instant answers about our AEPS, DMT, Verify APIs, and Recharge platforms." 
          isDark={true}
        />
      </div>

      {/* Newsletter Subscription Bar */}
      <section className="newsletter_section py-5" style={{ backgroundColor: '#001a14', borderTop: '1px solid rgba(204, 255, 0, 0.1)' }}>
        <div className="container">
          <div className="row align-items-center g-4 justify-content-between">
            <div className="col-lg-5">
              <h3 className="h3 text-white font-weight-bold mb-1">Subscribe for daily update</h3>
              <p className="text-white-50 small mb-0">Get latest fintech API updates, product releases &amp; special offers directly to your inbox.</p>
            </div>
            <div className="col-lg-6">
              <form onSubmit={handleNewsletterSubmit} className="d-flex gap-2">
                <input 
                  type="email" 
                  className="form-control form-control-lg rounded-3 border-0 px-3"
                  placeholder="Enter your email address..." 
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  required 
                  style={{ backgroundColor: '#ffffff', color: '#012b2a', fontSize: '0.95rem' }}
                />
                <button type="submit" className="btn-lime px-4 py-2 rounded-3 flex-shrink-0 shadow">
                  <i className="fa-solid fa-paper-plane"></i>
                </button>
              </form>
              {subscribed && (
                <div className="small text-lime font-weight-bold mt-2">
                  <i className="fa-solid fa-circle-check me-1"></i> Thank you for subscribing to Mokshiq daily updates!
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}

export default Index;